import { Type } from '@sinclair/typebox';
import { AttributesSchema, AttributeValueMultiSchema, FamilyNameSchema, ProductItemSchema, ProductNameSchema, UseFiltersSchema } from "./shared.mjs";
export const GetFamiliesQuerySchema = Type.Object({
    name: Type.Optional(FamilyNameSchema),
});
export const GetFamiliesResponseSchema = Type.Object({
    families: Type.Record(Type.String(), Type.Object({
        name: Type.String(),
        supported: Type.Array(Type.String()),
        required: Type.Array(Type.String()),
        products: Type.Record(Type.String(), Type.Object({
            name: Type.String(),
            attributes: AttributesSchema,
            sku: Type.String(),
            available: Type.Boolean(),
        })),
    })),
});
export const GetAttributesQuerySchema = Type.Object({
    name: Type.Optional(Type.String()),
});
export const GetAttributesResponseSchema = Type.Object({
    attributes: Type.Record(Type.String(), Type.Object({
        name: Type.String(),
        values: AttributeValueMultiSchema,
        dynamic: Type.Boolean(),
        multi: Type.Boolean(),
        type: Type.String(),
    })),
});
export const GetAttributesMapResponseSchema = Type.Object({
    attributes: Type.Any(),
});
export const GetMinimumQuantityQuerySchema = Type.Object({
    attributes: Type.String(),
});
export const GetMinimumQuantityResponseSchema = Type.Object({
    minimumQuantity: Type.Number(),
});
export const GetConditionableMapResponseSchema = Type.Object({
    map: Type.Record(Type.String(), Type.Any()),
});
export const ValidationQuerySchema = Type.Object({
    attributes: Type.String(),
    allowUnsupportedAttributeAliases: Type.Boolean(),
    allowUnsuggestedAttributeValues: Type.Boolean(),
    checkAgainstFilteredValues: UseFiltersSchema,
});
export const ValidationResponseSchema = Type.Object({
    validation: Type.Object({
        valid: Type.Boolean(),
        error: Type.Optional(Type.Object({
            name: Type.String(),
            message: Type.String(),
        })),
    }),
});
export const CreateItemQuerySchema = Type.Object({
    attributes: Type.Optional(Type.String()),
    useFilters: UseFiltersSchema,
});
export const CreateItemResponseSchema = ProductItemSchema;
export const GetSizeDetailsQuerySchema = Type.Object({
    attributes: Type.String(),
    useFilters: UseFiltersSchema,
});
export const GetSizeDetailsResponseSchema = Type.Record(Type.String(), Type.Any());
export const IsAttributeAvailableResponseSchema = Type.Object({
    available: Type.Boolean(),
});
export const IsAttributeAvailableQuerySchema = Type.Object({
    item: Type.String(),
    useFilters: UseFiltersSchema,
});
export const isAttributeRequiredQuerySchema = Type.Object({
    family: FamilyNameSchema,
    name: ProductNameSchema,
});
export const isAttributeRequiredResponseSchema = Type.Object({
    required: Type.Boolean(),
});
export const GetFixedQuantityQuerySchema = Type.Object({
    attributes: Type.String(),
    useFilters: UseFiltersSchema,
});
export const GetFixedQuantityResponseSchema = Type.Object({
    fixedQuantity: Type.Boolean(),
});
export const GetLegacySKUQuerySchema = Type.Object({
    attributes: Type.String(),
});
export const GetLegacySKUResponseSchema = Type.Object({
    legacySKU: Type.Number(),
});
export const GetOutOfStockResponseSchema = Type.Object({
    outOfStock: Type.Array(Type.String()),
});
export const ErrorResponseSchema = Type.Object({
    message: Type.String(),
});
//# sourceMappingURL=product.js.map